
export default class AtividadeApontamentoAgrupamentoFiltro {

    tipoAgrupamento: string;
    dataInicio: Date | null;
    dataFim: Date | null;
    idTecnico: number | null;
    idCliente: number | null;
    idAtividade: number | null;
    cobranca: boolean | null;
    faturado: boolean | null;
    mostraUsuariosInativos: boolean;
    verDescricao: boolean;

    constructor(
        tipoAgrupamento = 'U',
        dataInicio = null,
        dataFim = null,
        idTecnico = null,
        idCliente = null,
        idAtividade = null,
        cobranca = null,
        faturado = null,
        mostraUsuariosInativos = false,
        verDescricao = false
    ) {
        this.tipoAgrupamento = tipoAgrupamento;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.idTecnico = idTecnico;
        this.idCliente = idCliente;
        this.idAtividade = idAtividade;
        this.cobranca = cobranca;
        this.faturado = faturado;
        this.mostraUsuariosInativos = mostraUsuariosInativos;
        this.verDescricao = verDescricao;
    }

}
